module.exports = __webpack_public_path__ + "img/eyelids.fb423424.svg";